import React, { useState } from "react"
import { Box, Button, Grid, Paper, TextField, Typography } from "@material-ui/core"
import { VpnKey } from "@material-ui/icons"
import { useSnackbar } from "../../../utils/notificacoes"
import { useEdicaoClienteContext } from "../context/useEdicaoClienteContext"
import { useCardStyles } from "./estilosCards"

export function AlterarSenhaCliente() {
    const classes = useCardStyles()
    const { alterarSenha } = useEdicaoClienteContext()
    const { enqueueSnackbar } = useSnackbar()

    const alertStart = (msg: string, tipo: "success" | "error" | "info") => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const [novaSenha, setNovaSenha] = useState("")
    const [confirmacao, setConfirmacao] = useState("")

    const handleAlterar = async () => {
        if (novaSenha.length < 6 || confirmacao.length < 6) {
            alertStart("Senha Inválida! Digite uma senha com no minimo 6 caracteres.", "error")
            return
        }
        if (novaSenha !== confirmacao) {
            alertStart("Senha Inválida! Os campos não sao iguais", "error")
            return
        }

        try {
            const mensagem = await alterarSenha(novaSenha, confirmacao)
            alertStart(mensagem, "success")
            setNovaSenha("")
            setConfirmacao("")
        } catch (error) {
            alertStart((error as Error).message || "Erro ao alterar a senha", "error")
        }
    }

    return (
        <Paper className={classes.configCard}>
            <Box className={classes.cardHeader}>
                <VpnKey className={classes.iconHeader} />
                <Typography variant="h6" className={classes.cardHeaderTitle}>
                    Alterar senha
                </Typography>
            </Box>

            <Box className={classes.cardContent}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Nova Senha"
                            type="password"
                            variant="outlined"
                            size="small"
                            fullWidth
                            autoComplete="new-password"
                            value={novaSenha}
                            onChange={e => setNovaSenha(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label="Confirmação da Nova Senha"
                            type="password"
                            variant="outlined"
                            size="small"
                            fullWidth
                            autoComplete="new-password"
                            value={confirmacao}
                            onChange={e => setConfirmacao(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Button
                            variant="contained"
                            className={classes.botaoSalvar}
                            onClick={handleAlterar}
                        >
                            Alterar senha
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    )
}
